import { render, staticRenderFns } from "./commodsDetail.vue?vue&type=template&id=3c33f7a8&scoped=true"
import script from "./commodsDetail.vue?vue&type=script&lang=ts"
export * from "./commodsDetail.vue?vue&type=script&lang=ts"
import style0 from "./commodsDetail.vue?vue&type=style&index=0&id=3c33f7a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c33f7a8",
  null
  
)

export default component.exports